module.exports = __webpack_public_path__ + "static/media/istockphoto-841246134-612x612.e249f149.jpg";